<template>
  <div>
    <div class="card bg-pattern shadow-none auth-card">
      <div class="card-body">
        <div class="text-center mt-4">
          <div class="mb-3">
            <a routerLink="/">
              <img
                class="logo"
                :src="URL_LOCAL_FILE + '/images/logo-dxperts.png'"
                alt="Logo"
              />
            </a>
          </div>
        </div>
        <div>
          <h4 class="font-size-18 mt-2 text-center">
            {{ $t('reset_pwd.title') }}
          </h4>
          <p class="text-muted text-center mb-4">
            {{ $t('reset_pwd.introduction') }}
          </p>
          <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
            <div class="form-group mb-4">
              <label for="email">{{ $t('reset_pwd.email') }}</label>
              <div class="input-group">
                <div class="input-group-prepend bg-transparent">
                  <span class="input-group-text bg-transprent border-right-0">
                    <i class="fas fa-envelope text-custom-primary"></i>
                  </span>
                </div>
                <input
                  v-model="form.email"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': form.errors.has('email') }"
                  id="email"
                  :placeholder="$t('reset_pwd.email')"
                  required
                  autofocus
                />
                <has-error :form="form" field="email"></has-error>
              </div>
            </div>

            <div class="form-group mb-4">
              <label for="password">{{ $t('reset_pwd.pwd') }}</label>
              <div class="input-group">
                <div class="input-group-prepend bg-transparent">
                  <span class="input-group-text bg-transprent border-right-0">
                    <i class="fas fa-lock text-custom-primary"></i>
                  </span>
                </div>
                <input
                  id="password"
                  v-model="form.password"
                  class="form-control"
                  :class="{ 'is-invalid': form.errors.has('password') }"
                  :type="show_password ? 'text' : 'password'"
                  :placeholder="$t('reset_pwd.pwd')"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text btn"
                    @click="show_password = !show_password"
                  >
                    <i
                      :class="show_password ? 'fas fa-eye' : 'fas fa-eye-slash'"
                    ></i>
                  </span>
                </div>
                <has-error :form="form" field="password"></has-error>
              </div>
            </div>

            <div class="form-group mb-4">
              <label for="password-confirmation">
                {{ $t('reset_pwd.pwdConfirm') }}
              </label>
              <div class="input-group">
                <div class="input-group-prepend bg-transparent">
                  <span class="input-group-text bg-transprent border-right-0">
                    <i class="fas fa-lock text-custom-primary"></i>
                  </span>
                </div>
                <input
                  v-model="form.password_confirmation"
                  id="password-confirmation"
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('password_confirmation'),
                  }"
                  :type="show_password_confirm ? 'text' : 'password'"
                  :placeholder="$t('reset_pwd.pwdConfirm')"
                  required
                  autocomplete="new-password"
                />
                <has-error
                  :form="form"
                  field="password_confirmation"
                ></has-error>
                <div class="input-group-append">
                  <span
                    class="input-group-text btn"
                    @click="show_password_confirm = !show_password_confirm"
                  >
                    <i
                      :class="
                        show_password_confirm
                          ? 'fas fa-eye'
                          : 'fas fa-eye-slash'
                      "
                    ></i>
                  </span>
                </div>
              </div>
            </div>

            <div class="mt-4 px-5">
              <ButtonLoader
                :busy="form.busy"
                type="submit"
                customClass="btn btn-custom-primary btn-block"
                loadText="Traitement en cours..."
                :Text="$t('reset_pwd.reinitButton')"
              ></ButtonLoader>
            </div>

            <div class="mt-4 text-center">
              <router-link
                :to="{ name: 'login' }"
                v-slot="{ href, navigate }"
                custom
              >
                <a :href="href" @click="navigate">
                  <i class="mdi mdi-login"></i>
                  {{ $t('reset_pwd.seConnecter') }}
                </a>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer';
import Form from 'vform';
import URL from '@/http/auth.url';
import config from '@/config';

export default {
  name: 'PasswordReset',
  data() {
    return {
      form: new Form({
        token: '',
        email: '',
        password: '',
        password_confirmation: '',
      }),
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
      title: 'Réinitialisation du mot de passe',
      show_password: false,
      show_password_confirm: false,
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  created: function () {
    this.form.email = this.$route.params.email;
    this.form.token = this.$route.params.token;
  },
  components: {
    Footer,
  },
  methods: {
    submit() {
      this.form
        .post(URL.RESET_PASSWORD)
        .then((resp) => {
          this.$swal({
            position: 'top-end',
            icon: 'success',
            text: resp.data.message,
            showConfirmButton: false,
            timer: window.Timer,
          }).then(() => {
            this.$router.push({ name: 'login' });
          });
          this.form.reset();
        })
        .catch((err) => {
          if (
            err.response.data.message !== undefined &&
            err.response.data.message !== '' &&
            err.response.data.errors.length === 0
          )
            this.showSimpleAlerte(
              'top-end',
              'error',
              err.response.data.message
            );
        });
    },
  },
};
</script>

<style scoped></style>
